import { combineReducers } from "redux"
import { users } from "./usersReducer"

const usersReducer = combineReducers({
    users
})

export default usersReducer
